// extracted by mini-css-extract-plugin
export var active = "_dq-7";
export var container = "_dq-0";
export var evenWidth = "_dq-4";
export var large = "_dq-5";
export var outlet = "_dq-8";
export var slide = "_dq-2";
export var small = "_dq-6";
export var tab = "_dq-3";
export var tabs = "_dq-1";